import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./PrivacyModal.css"; 

const PrivacyModal = ({ isOpen, onClose, onConfirm }) => {
  const { t } = useTranslation("privacy");
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-window">
        <div className="popup_wrap">
          <div>
            <h3 className="privacy_title">{t("title")}</h3>
            <p className="privacy_content" style={{ whiteSpace: "pre-line" }}>
				{t("privacy_policy")}
            </p>
          </div>
		  <label htmlFor="agr" className="ch_box">
			<input type="checkbox" id="agr" name="agr" value="1" />
			<span id="privacy_check">{t("agree_text")}</span>
		  </label>
		  <div>
			<span className="cancel-button" onClick={onClose}>{t("cancel")}</span>
			<span className="confirm-button" onClick={() => { const isChecked = document.getElementById("agr").checked; if (isChecked) {  onConfirm();  } else { alert(t("agree_alert")); } }}> {t("confirm")} </span>
 		   </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyModal;
